export default "__VITE_ASSET__CsS1ZcX___"